module.exports = __webpack_public_path__ + "img/flow4.df50e7f6.png";